import { DISPLAY_ACCESS_CODE_RESULT } from 'actiontypes/accessCodes';

export default function displayAccessCodeResult(result) {
  return { type: DISPLAY_ACCESS_CODE_RESULT, payload: result };
}